<template>
  <main id="main" class="main">
    <div class="">
      <div class="">
        <router-view/>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      currentLanguage: null,
      isCollapsedMenu: false,
      openLanguage: false
    }
  },
  computed: {
    beautySelectedAddress () {
      const firstStr = this.selectedAddress.substring(0, 6)
      const lastStr = this.selectedAddress.substring(this.selectedAddress.length - 5, this.selectedAddress.length)
      return firstStr + '...' + lastStr
    },
    isConnectedWallet () {
      return this.bridgeConnector.bridge || this.web3.currentProvider
    },
    ethereum () {
      return this.$store.getters.ethereum
    },
    web3 () {
      return this.$store.getters.web3
    },
    currentLang () {
      return this.$store.getters.currentLang
    },
    languages () {
      return this.$store.getters.languages
    },
    configs () {
      return this.$store.getters.configs
    },
    user () {
      return this.$store.getters.user
    },
    activeRound () {
      return this.$store.getters.activeRound
    },
    bridgeConnector () {
      return this.$store.getters.bridgeConnector
    },
    selectedAddress () {
      return this.$store.getters.selectedAddress
    },
    isConnected () {
      return this.$store.getters.isConnected
    }
  },
  mounted () {
    window.onhashchange = function (event) {
      // blah blah blah
      event.preventDefault()
      return false
    }
  },
  watch: {
    currentLang (val) {
      val && (this.currentLanguage = val)
    },
    $route () {
      const ww = window.innerWidth
      if (ww < 1200 && this.isCollapsedMenu) {
        this.isCollapsedMenu = false
      }
    }
  }
}
</script>
